'use client'

import * as React from 'react'
import { cn } from '@/lib/css-utils'
import {
  DrawerClose,
  DrawerContent,
  DrawerPortal,
  DrawerTrigger,
  DrawerOverlay,
} from '@/components/ui/drawer'
import { X } from 'lucide-react'
import { Drawer as DrawerPrimitive } from 'vaul'
import { DialogTitle } from '@radix-ui/react-dialog'

export const BottomSheet = (
  props: React.ComponentProps<typeof DrawerPrimitive.Root>,
) => <DrawerPrimitive.Root {...props} />
BottomSheet.displayName = 'BottomSheet'

export const BottomSheetTrigger = DrawerTrigger
export const BottomSheetClose = DrawerClose

interface BottomSheetContentProps
  extends React.ComponentPropsWithoutRef<typeof DrawerContent> {
  title?: string
  showHandle?: boolean
  showCloseButton?: boolean
  onCloseClick?: () => void
}

export const BottomSheetContent = React.forwardRef<
  React.ComponentRef<typeof DrawerContent>,
  BottomSheetContentProps
>(
  (
    {
      className,
      children,
      title,
      showHandle = false,
      showCloseButton = true,
      onCloseClick,
      ...props
    },
    ref,
  ) => (
    <DrawerPortal>
      <DrawerOverlay />
      <DrawerContent
        ref={ref}
        className={cn(
          `fixed left-0 right-0 bottom-0 flex h-auto flex-col rounded-t-xl border-0 bg-background-primary border-t 
          border-border-muted`,
          className,
        )}
        {...props}
      >
        {showHandle && (
          <div className="mx-auto mt-4 h-1 w-12 rounded-full bg-border-muted" />
        )}

        <div className="flex items-center justify-between px-4 py-3">
          {title && (
            <>
              <DialogTitle className="sr-only">{title}</DialogTitle>
              <span className="text-md w-full font-semibold text-copy-primary text-center">
                {title}
              </span>
            </>
          )}
          {showCloseButton && (
            <DrawerClose className="rounded-full p-1" onClick={onCloseClick}>
              <X className="h-5 w-5 text-copy-primary" />
              <span className="sr-only">Close</span>
            </DrawerClose>
          )}
        </div>

        <div className="px-4 pb-4 flex-1 overflow-auto">{children}</div>
      </DrawerContent>
    </DrawerPortal>
  ),
)
BottomSheetContent.displayName = 'BottomSheetContent'
